import styled from 'styled-components';
import { onMobile } from '../../common/styles/onMobile';
import { responsiveInterpolate } from '../../common/styles/responsiveInterpolate';

const CARDS_WIDTH = 592;
const CARDS_MARGIN_RIGHT = 88;
const SIDEBAR_WIDTH = 302;

const EXPECTED_CONTENT_WIDTH = CARDS_WIDTH + CARDS_MARGIN_RIGHT + SIDEBAR_WIDTH;

export const CardsContainer = styled.div`
  box-sizing: border-box;
  margin-inline-end: ${responsiveInterpolate(0, CARDS_MARGIN_RIGHT)};
  max-width: ${CARDS_WIDTH}px;

  ${onMobile} {
    margin-inline-end: unset;
    max-width: unset;
    width: 100%;
  }
`;

export const SidebarContainer = styled.div`
  max-width: ${SIDEBAR_WIDTH}px;

  // Don't show on thin desktop views
  @media (max-width: ${EXPECTED_CONTENT_WIDTH}px) {
    display: none;
  }
`;
